module.exports = __webpack_public_path__ + "static/media/S1-33-Zartroworb-cod64.2dd30001.png";